export default __webpack_public_path__ + "static/media/GO-ON.a69a3f71.png";